import React, { useState, useEffect, useLayoutEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useExecuteHistoryQuery, useExecuteSummaryQuery } from "src/api/userAPI";
import { getPathValue } from "src/utils/queryStringUtil";
import cn from "classnames";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import Box from "src/components/common/Box";
import SVG from "src/utils/SVG";
import noFulfill from "src/assets/images/no_fulfill_img.png";
import selectArrowGrey from "src/assets/images/selectArrowGrey.svg";
import icoStar from "src/assets/images/icoStar.svg";
import icoStarActive from "src/assets/images/icoStarActive.svg";
import styled from "styled-components";
import { isEmpty } from "lodash";

const FulfilledDetail = () => {
  // global
  const navigate = useNavigate();
  const navigateState = useLocation();
  const storeId: any = getPathValue();
  const imageServerIp = process.env.REACT_APP_IMAGE_SERVER_IP;

  // state
  const [exeRateData, setExeRateData] = useState<any>([]);
  const [exeScoreData, setExeScoreData] = useState<any>([]);
  const [exeListData, setExeListData] = useState<any>([]);

  const [yearSelected, setYearSelected] = useState("");
  const [seasonSelected, setSeasonSelected] = useState("");
  const [queryString, setQueryString] = useState("");

  // API
  const executeSum = useExecuteSummaryQuery({ user_id: storeId, queryString: queryString }, { skip: yearSelected === "" && seasonSelected === "" });
  const executeHistory = useExecuteHistoryQuery({ user_id: storeId, queryString: queryString }, { skip: yearSelected === "" && seasonSelected === "" });

  useEffect(() => {
    if (!isEmpty(navigateState.state)) {
      const state: any = navigateState.state;
      setYearSelected(state.data.seasonInfo.year);
      setSeasonSelected(state.data.seasonInfo.season);
    }
    setYearList();
  }, []);

  useEffect(() => {
    setQueryString(`search_year=${yearSelected}&search_season=${seasonSelected}`);
  }, [yearSelected, seasonSelected]);

  useEffect(() => {
    if (executeSum.isSuccess) {
      setExeRateData(executeSum.data.data.getProfileNoticeTotalCountAsStore);
      setExeScoreData(executeSum.data.data.profileNoticeRate);
    }
  }, [executeSum]);

  useEffect(() => {
    if (executeHistory.isSuccess) {
      setExeListData(executeHistory.data);
    }
  }, [executeHistory]);

  const handleYearSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setYearSelected(e.target.value);
  };

  const handleSeasonSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSeasonSelected(e.target.value);
  };

  const setYearList = () => {
    const currentYear = new Date().getFullYear();
    const selectYear = [];
    for (let i = 2022; i <= currentYear; i++) {
      selectYear.push({
        value: String(i),
        name: String(i),
      });
    }
    return selectYear;
  };

  const selectSeason = [
    {
      value: "ALL",
      name: "전체",
    },
    {
      value: "SS",
      name: "SS",
    },
    {
      value: "FW",
      name: "FW",
    },
  ];

  const moveToDetail = (nxInfo: any) => {
    if (nxInfo.execute_yn === "Y") {
      navigate(`/fulfill-detail/` + nxInfo.execute_idx);
    } else {
      if (nxInfo.re_execute_yn === "Y") {
        navigate(`/fulfill-detail/` + nxInfo.execute_idx);
      } else {
        navigate(`/notice-detail/` + nxInfo.notice_idx);
      }
    }
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => navigate(-1)}>
            공지이행 이력
          </Button>
        </div>
      </header>

      <Body>
        <FilterWrap>
          <dt>필터</dt>
          <dd>
            <select id="selectYear" value={yearSelected} onChange={handleYearSelect}>
              {setYearList().map((v, i) => (
                <option value={v.value} key={i}>
                  {v.name}
                </option>
              ))}
            </select>
            <select id="selectSeason" value={seasonSelected} onChange={handleSeasonSelect}>
              {selectSeason.map((v, i) => (
                <option value={v.value} key={i}>
                  {v.name}
                </option>
              ))}
            </select>
          </dd>
        </FilterWrap>

        <Box pd="32px 15px 0">
          <NoticeFulfillDash>
            <>
              {exeRateData && (
                <div>
                  <dt>이행률</dt>
                  <dd className="flex-box">
                    <p>
                      <span>{exeRateData.executeRate ? exeRateData.executeRate : 0}</span>%
                    </p>
                    <p>
                      {exeRateData.execute_count ? exeRateData.execute_count : 0} / {exeRateData.total_count ? exeRateData.total_count : 0}
                    </p>
                  </dd>
                </div>
              )}
              {exeScoreData && (
                <div>
                  <dt>별점</dt>
                  <dd>
                    <div className={cn("score", { disabled: exeScoreData.score === null })}>
                      <SVG name="star" width={20} height={20} viewBox="0 0 20 20" />
                      <span>{exeScoreData.score >= 0 && exeScoreData.score !== null ? exeScoreData.score : "-"}</span>
                    </div>
                  </dd>
                </div>
              )}
            </>
          </NoticeFulfillDash>
          <NotiText>'평가완료'되지 않은 건은 이행률에 포함되지 않습니다.</NotiText>
        </Box>

        <div>
          <GalleryList>
            {exeListData && exeListData.length > 0 ? (
              exeListData.map((v: any, i: number) => {
                return (
                  <li key={i} className={cn({ redeem: v.re_execute_yn === "Y", noExecute: v.execute_yn === "N" })}>
                    <div onClick={() => moveToDetail(v)}>
                      <div className="img-box">
                        {v.img_url ? <img src={imageServerIp + v.img_url} alt="더미이미지" /> : <img src={noFulfill} alt="더미이미지" />}
                        {v.re_execute_yn === "Y" && <span className="remark-re">재이행</span>}
                      </div>
                      <div className="sub-info">
                        <p className="category">{v.category_name}</p>
                        {v.score !== null ? (
                          <span className="star-score active">{v.score}</span>
                        ) : v.execute_yn === "Y" ? (
                          <span className="star-score">-</span>
                        ) : (
                          ""
                        )}
                      </div>
                      <p className="title">{v.title}</p>
                    </div>
                  </li>
                );
              })
            ) : (
              <NoResult>리스트 결과가 없습니다.</NoResult>
            )}
          </GalleryList>
        </div>
      </Body>
    </>
  );
};

const NotiText = styled.p`
  padding-left: 10px;
  margin-top: 10px;
  color: ${({ theme }) => theme.color.quaternary};
  font-size: 12px;
`;

const FilterWrap = styled.dl`
  ${({ theme }) => theme.flexBox.flexMixin()}
  padding: 30px 15px 8px;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  dt {
    color: ${({ theme }) => theme.color.tertiary};
    font-size: 14px;
    font-weight: 500;
  }
  dd {
    select {
      position: relative;
      display: inline-block;
      padding: 6px 30px 6px 10px;
      border: 1px solid ${({ theme }) => theme.color.linePrimary};
      border-radius: 4px;
      margin-left: 8px;
      color: ${({ theme }) => theme.color.tertiary};
      font-size: 14px;
      background: url(${selectArrowGrey}) no-repeat right center;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      &:focus {
        outline: none;
      }
    }
  }
`;

const NoticeFulfillDash = styled.dl`
  ${({ theme }) => theme.flexBox.flexMixin("row", "space-around", "center")}
  > div {
    position: relative;
    ${({ theme }) => theme.flexBox.flexMixin("column", "center", "flex-start")}
    flex: 1;
    height: 45px;
    padding-left: 18px;
    margin-left: 15px;
    color: ${({ theme }) => theme.color.secondary};
    font-size: 14px;
    text-align: left;
    dt {
      margin-bottom: 3px;
      font-size: 12px;
      font-weight: 500;
      text-transform: uppercase;
    }
    dd {
      color: #000;
      line-height: 20px;
      &.flex-box {
        ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "flex-end")}
        > p {
          &:first-child {
            > span {
              font-family: "Poppins";
              font-size: 18px;
              font-weight: 500;
              line-height: 20px;
            }
          }
          &:last-child {
            margin-left: 16px;
            color: ${({ theme }) => theme.color.secondary};
          }
        }
      }
      .score {
        > span {
          position: relative;
          top: 1px;
          margin-left: 4px;
        }
      }
    }
    &:first-child {
      margin-left: 0;
    }
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      display: inline-block;
      width: 1.5px;
      height: 100%;
      border-radius: 3px;
      background-color: #8c96aa;
    }
  }
`;

const GalleryList = styled.ul`
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "stretch", "wrap")}
  width: 100%;
  padding: 30px 1px 0 15px;
  > li {
    position: relative;
    width: 50%;
    padding: 0 14px 24px 0;
    > div {
      display: block;
      width: 100%;
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
      .img-box {
        ${({ theme }) => theme.imgBox.coverBox()};
        .remark-re {
          z-index: 10;
          position: absolute;
          top: 8px;
          left: 8px;
          display: inline-block;
          padding: 2px 10px;
          margin-right: 8px;
          background-color: ${({ theme }) => theme.color.main};
          color: #fff;
          font-size: 12px;
          line-height: 18px;
          text-align: center;
        }
      }
      .sub-info {
        ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "center")}
        .category {
          margin-top: 4px;
          color: ${({ theme }) => theme.color.tertiary};
        }
        .star-score {
          position: relative;
          top: 1px;
          display: inline-block;
          padding-left: 18px;
          font-family: "Poppins";
          line-height: 20px;
          background: url(${icoStar}) no-repeat left 2px;
          &.active {
            background: url(${icoStarActive}) no-repeat left 2px;
          }
        }
      }
      .title {
        margin-top: 4px;
        ${({ theme }) => theme.textOverflow.singleLine()};
      }
    }
    /* &.redeem {
      &:before {
        content: "재이행";
        z-index: 1;
        position: absolute;
        top: 8px;
        left: 8px;
        display: inline-block;
        width: auto;
        height: 16px;
        padding: 0 4px;
        background-color: ${({ theme }) => theme.color.main};
        color: #fff;
        font-size: 10px;
        line-height: 16px;
        text-align: center;
      }
    } */
  }
`;

const NoResult = styled.li`
  width: 100% !important;
  padding-top: 40px;
  margin: 80px 0 40px;
  text-align: center;
`;

export default FulfilledDetail;
